import React, { useEffect, useState } from "react";
import Menu from "../panel/Menu";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Chip,
    Grid,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Pagination
} from "@mui/material";
import { EditOutlined, DeleteOutline } from "@mui/icons-material";
import {
    collection,
    getDocs,
    doc,
    setDoc,
    deleteDoc,
    query,
    where,
    Timestamp
} from "firebase/firestore";
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { db } from "../firebase";
import Swal from "sweetalert2";

/* ================= CONSTANTS ================= */
const PAGE_SIZE = 5;
const ROLE_OPTIONS = [
    "Reception",
    // "Desk Manager",
    "Accountant",
    "Store",
    // "Checkout Manager",
    "General Manager",
    // "Hotelowner",
    "Housekeeping",
    // "Parking",
    "Restoadmin",
    "Captain",
    "Manager",
    "Chef",
];

function Userlogins() {
    const auth = getAuth();

    const [userId, setUserId] = useState(null);
    const [propertyId, setPropertyId] = useState(null);

    const [users, setUsers] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [loginemail, setloginemail] = useState("");
    const [loginpass, setloginpass] = useState("");

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);

    const [form, setForm] = useState({
        name: "",
        email: "",
        mobile: "",
        password: "",
        role: "Reception",
        status: "Active",
        propertyId: ""
    });

    /* ================= AUTH ================= */
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (user) => {
            if (!user) return;
            setUserId(user.uid);

            const snap = await getDocs(collection(db, "authroles"));
            snap.forEach(d => {
                if (d.id === user.uid) {
                    setPropertyId(d.data().propertyId);
                    setloginemail(d.data().email);
                    setloginpass(d.data().password);
                }
            });
        });
        return () => unsub();
    }, []);

    /* ================= LOAD USERS ================= */
    useEffect(() => {
        if (!propertyId) return;
        loadUsers();
    }, [propertyId]);

    const loadUsers = async () => {
        const q = query(
            collection(db, "authroles"),
            where("propertyId", "==", propertyId)
        );
        const snap = await getDocs(q);
        setUsers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    /* ================= HANDLERS ================= */
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const saveUser = async () => {



        // Create user with email and password
        const userCredential = await createUserWithEmailAndPassword(auth, form.email, form.password);
        const user = userCredential.user; // Newly created user


        await setDoc(doc(db, "authroles", user.uid), {
            uid: user.uid,
            ...form,
            propertyId,
            createdTime: editingId ? form.createdTime : Timestamp.now()
        });

        // Optional: sign out the current user and sign in back with admin credentials
        await auth.signOut();
        await signInWithEmailAndPassword(auth, loginemail, loginpass); // Ensure loginemail/loginpass are available

        Swal.fire("Success", editingId ? "User updated" : "User added", "success");

        setForm({
            uid: "",
            name: "",
            email: "",
            mobile: "",
            password: "",
            role: "Reception",
            status: "Active",
            propertyId: ""
        });

        setEditingId(null);
        loadUsers();
    };

    const editUser = (u) => {
        setForm(u);
        setEditingId(u.uid);
    };

    const deleteUser = async (uid) => {
        const res = await Swal.fire({
            title: "Delete user?",
            icon: "warning",
            showCancelButton: true
        });

        if (!res.isConfirmed) return;

        await deleteDoc(doc(db, "authroles", uid));
        Swal.fire("Deleted", "User removed", "success");
        loadUsers();
    };

    /* ================= FILTER + PAGINATION ================= */
    const filtered = users.filter(u =>
        u.name?.toLowerCase().includes(search.toLowerCase()) ||
        u.email?.toLowerCase().includes(search.toLowerCase())
    );

    const paginated = filtered.slice(
        (page - 1) * PAGE_SIZE,
        page * PAGE_SIZE
    );

    return (
        <Box display="flex" minHeight="100vh" bgcolor="#f4f6f8">
            <Menu />

            <Box className="content-wrapper" flex={1} p={3}>
                <Typography variant="h5" fontWeight={800} mb={2}>
                    User Logins
                </Typography>

                {/* ================= FORM ================= */}
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <Typography fontWeight={700} mb={2}>
                            {editingId ? "Edit User" : "Add New User"}
                        </Typography>

                        <Grid className="row" spacing={2}>

                            <Grid className="col-sm-3 mb-3">
                                <TextField fullWidth size="small" label="Name" name="name" value={form.name} onChange={handleChange} />
                            </Grid>
                            <Grid className="col-sm-3 mb-3">
                                <TextField fullWidth size="small" label="Email" name="email" value={form.email} onChange={handleChange} />
                            </Grid>
                            <Grid className="col-sm-3 mb-3">
                                <TextField fullWidth size="small" label="Mobile" name="mobile" value={form.mobile} onChange={handleChange} />
                            </Grid>

                            <Grid className="col-sm-3 mb-3">
                                <TextField fullWidth size="small" label="Password" name="password" value={form.password} onChange={handleChange} />
                            </Grid>

                            <Grid className="col-sm-3 mb-3">
                                <FormControl fullWidth size="small">
                                    <InputLabel>Role</InputLabel>
                                    <Select name="role" value={form.role} onChange={handleChange}>
                                        {ROLE_OPTIONS.map(r => (
                                            <MenuItem key={r} value={r}>{r}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Button variant="contained" sx={{ mt: 2 }} onClick={saveUser}>
                            {editingId ? "Update User" : "Add User"}
                        </Button>
                    </CardContent>
                </Card>

                {/* ================= SEARCH ================= */}
                <TextField
                    fullWidth
                    label="Search by name or email"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    sx={{ mb: 2 }}
                />

                {/* ================= TABLE ================= */}
                <Card>
                    <CardContent>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr No</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Mobile</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Role</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>


                            <TableBody>
                                {paginated.map((u, index) => (
                                    <TableRow key={u.uid}>
                                        <TableCell>
                                            {(page - 1) * PAGE_SIZE + index + 1}
                                        </TableCell>
                                        <TableCell>{u.name}</TableCell>
                                        <TableCell>{u.mobile}</TableCell>
                                        <TableCell>{u.email}</TableCell>
                                        <TableCell>{u.role}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={u.status}
                                                color={u.status === "Active" ? "success" : "default"}
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {/* Actions */}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>

                        </Table>

                        <Box display="flex" justifyContent="center" mt={2}>
                            <Pagination
                                count={Math.ceil(filtered.length / PAGE_SIZE)}
                                page={page}
                                onChange={(e, v) => setPage(v)}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
}

export default Userlogins;
